module.exports = {
  title: 'Нет данных',
};
